import { useSiteSettingsFromContext } from "@/contexts/SiteSettingsContext";

export function useSiteSettings() {
  return useSiteSettingsFromContext();
}
